import React, { useContext, useEffect, useState, useRef } from 'react';
import Navbar from '../navbar/navbar.comp';
import Button from "../../components/button/button.comp";
import './create.style.scss';
import CreateEvent from '../createEvent/createEvent.comp.jsx';
import { UserContext } from '../../contexts/user.context.jsx';
import { uploadCreatedChallenge, trackChallengeCreation } from '../../utils/firebase/firebase.utils.js';
import challenges from '../../database/challenges.js';
import { useNavigate } from 'react-router-dom';

const Create = () => {

    const { userID } = useContext(UserContext)
    const navigate = useNavigate();

    const today = new Date();
    function formatDate(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    }
    const dateString = formatDate(today);

    const [formData, setFormData] = useState({
        channelID: false,
        // createdAt: added by serverTimestamp,
        title: '',
        subtitle: '',
        about: '',
        imageURL: '',
        videoURL: '',
        eventTitle: '',
        eventTime: '',
        eventsPerWeek: 0,
        weeks: 0,
    });

    const [image, setImage] = useState(null)

    useEffect(() => {
        setImage(formData.imageURL)
    }, [formData.imageURL])

    const [tags, setTags] = useState({
        tag1: '',
        tag2: '',
        tag3: ''
    })

    const updateInfo = (weeks, eventsPerWeek, eventTime) => {
        return `${weeks} week${weeks > 1 ? 's' : ''} · ${eventsPerWeek} event${eventsPerWeek > 1 ? 's' : ''} a week · ${eventTime}`;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };

    const testPrint = () => {
        console.log(formData)
        console.log(tags)
    }

    const handleEventTimeClick = (eventTime) => {
        setFormData((prevData) => ({
            ...prevData,
            eventTime,
            subtitle: updateInfo(prevData.weeks, prevData.eventsPerWeek, eventTime)
        }));
        console.log(eventTime)
    };

    const handleWeeksClick = (weeks) => {
        setFormData((prevData) => ({
            ...prevData,
            weeks,
            subtitle: updateInfo(weeks, prevData.eventsPerWeek, prevData.eventTime)
        }));
    };

    const handleEventsPerWeekClick = (eventsPerWeek) => {
        setFormData((prevData) => ({
            ...prevData,
            eventsPerWeek,
            subtitle: updateInfo(prevData.weeks, eventsPerWeek, prevData.eventTime)
        }));
    };


    //Pop Up: Intro
    const [displayIntro, setDisplayIntro] = useState(true);
    const toggleDisplay = () => {
        setDisplayIntro(!displayIntro)
    };
    const handleCloseIntroPopUp = () => {
        setDisplayIntro(false)
    }


    //Creating Challenge Phases
    const [phase1, setPhase1] = useState(true)
    const [phase2, setPhase2] = useState(false)
    const [phase3, setPhase3] = useState(false)
    const [lastPhase, setLastPhase] = useState(false)
    const handleFirstNext = () => {
        setPhase1(false)
        setPhase2(true)
        setPhase3(false)
    }
    const handleSecondNext = () => {
        setPhase1(false)
        setPhase2(false)
        setPhase3(true)
    }
    const handleFirstBack = () => {
        setPhase1(true)
        setPhase2(false)
        setPhase3(false)
    }
    const handleSecondBack = () => {
        setPhase1(false)
        setPhase2(true)
        setPhase3(false)
    }
    const handleThirdNext = () => {
        setPhase1(false)
        setPhase2(false)
        setPhase3(false)
        setLastPhase(true)
        setLastStepPopUp(true)

        createChallengeObject();
    }
    const handleThirdBack = () => {
        setPhase1(false)
        setPhase2(false)
        setPhase3(true)
        setLastPhase(false)
        setLastStepPopUp(false)
    }


    const [lastStepPopUp, setLastStepPopUp] = useState(false)
    const handleCloseLastStepPopUp = () => {
        setLastStepPopUp(false)
    }


    const createEventsArray = (weeks, eventsPerWeek) => {
        const events = [];
        let eventNumber = 1;

        for (let weekNumber = 1; weekNumber <= weeks; weekNumber++) {
            for (let eventOfWeekNumber = 1; eventOfWeekNumber <= eventsPerWeek; eventOfWeekNumber++) {
                events.push(eventNumber, weekNumber, eventOfWeekNumber, null, false);
                eventNumber++;
            }
        }

        return events;
    };
    const setTimeAndUnits = (timeString) => {
        let time;
        let units;

        if (timeString === '5 min') {
            time = 5;
            units = 'minutes';
        } else if (timeString === '10 min') {
            time = 10;
            units = 'minutes';
        } else if (timeString === '20 min') {
            time = 20;
            units = 'minutes';
        } else if (timeString === '30 min') {
            time = 30;
            units = 'minutes';
        } else if (timeString === '1 hour') {
            time = 1;
            units = 'hours';
        } else if (timeString === '2 hours') {
            time = 2;
            units = 'hours';
        } else {
            throw new Error('Invalid time format');
        }

        return { time, units };
    };
    const [challengeObject, setChallengeObject] = useState();
    const createChallengeObject = () => {

        const eventsTotal = formData.weeks * formData.eventsPerWeek;
        const events = createEventsArray(formData.weeks, formData.eventsPerWeek);

        setChallengeObject(
        {
                userID: userID,
                channelID: false,
                // createdAt: added by serverTimestamp,
                createdAtString: dateString,
                title: formData.title,
                subtitle: formData.subtitle,
                about: formData.about,
               
                imageURL: formData.imageURL,
                videoURL: formData.videoURL,

                eventTitle: formData.eventTitle,
                events: events,
                eventTime: formData.eventTime,
                eventsPerWeek: formData.eventsPerWeek,
                weeks: formData.weeks,
                eventsTotal: eventsTotal,
            }
        );
    }

    const printChallengeObject = () => {
        console.log(challengeObject)
        // console.log(formData)
    }


    //Saving to Firebase
    const [savePopUp, setSavePopUp] = useState(false)
    const [saving, setSaving] = useState(false)
    const [saved, setSaved] = useState(false)
    const handleSave = () => {
        setSavePopUp(true)
    }
    const handleCloseSavePop = () => {
        setSavePopUp(false)
    }
    const handleSubmitChallenge = async () => {
        try {

            setSaving(true)
            await uploadCreatedChallenge(challengeObject);

            trackChallengeCreation(challengeObject.title, userID)

            console.log('Challenge uploaded successfully.', challengeObject.title, userID);
            setSaving(false)
            setSaved(true)
        } catch (error) {
            console.error('Error uploading challenges:', error);
        }
    }
    const handleGoToChallenge = () => {
        setSavePopUp(false)
        navigate('/mychallenges');
    }


    const printChallenges = () => {
        console.log(challenges)
    }


    return (
        <div>
            {/* Navbar */}
            <div className='section'>
                <Navbar option={5} />
            </div>

            {/* Margin Top */}
            <div className="section frame" style={{ height: '44px' }} />

            {/* Challenge */}
            <div className="section frame">
                <div className="created-challenge columns">
                    <div className="image"
                        style={{
                            backgroundImage: image ? `url(${image})` : 'none',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat'
                        }}
                    >
                    </div>
                    <div className="created-challenge-info">
                        <div className="title">
                            <h2>{formData.title}</h2>
                        </div>
                        <div className="text">
                            <p style={{ fontWeight: "bold", width: "fit-content" }}>{formData.info}</p>

                            <p className='about-text' style={{ width: "fit-content" }}>
                                {
                                    formData.about.split('\n\n').map((paragraph, index) => (
                                        <React.Fragment key={index}>
                                            <p style={{ marginBottom: '12px', textAlign: 'left' }}>{paragraph}</p>
                                        </React.Fragment>
                                    ))
                                }
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Buttons */}
            <div className='section frame'>
                {
                    phase1 ? (
                        <div className="create-next-buttons">
                            <Button text={'Back'} option={'inactive'} />
                            {
                                formData.title &&
                                    formData.imageURL ? (
                                    <Button text={'Next'} option={'yellow'} onClick={handleFirstNext} />
                                ) : (
                                    <Button text={'Next'} option={'inactive'} />
                                )
                            }
                        </div>
                    ) : null
                }
                {
                    phase2 ? (
                        <div className="create-next-buttons">
                            <Button text={'Back'} option={'yellow'} onClick={handleFirstBack} />
                            {
                                formData.weeks && formData.eventsPerWeek && formData.eventTime && formData.eventTitle ? (
                                    <Button text={'Next'} option={'yellow'} onClick={handleSecondNext} />
                                ) : (
                                    <Button text={'Next'} option={'inactive'} />
                                )
                            }
                        </div>
                    ) : null
                }
                {
                    phase3 ? (
                        <div className="create-next-buttons">
                            <Button text={'Back'} option={'yellow'} onClick={handleSecondBack} />
                            {
                                image && formData.about ? (
                                    <Button text={'Next'} option={'yellow'} onClick={handleThirdNext} />
                                ) : (
                                    <Button text={'Next'} option={'inactive'} />
                                )
                            }
                        </div>
                    ) : null
                }
                {
                    lastPhase ? (
                        <div className="create-next-buttons-and-label">
                            <div className="create-next-buttons">
                                <Button text={'Back'} option={'yellow'} onClick={handleThirdBack} />
                                <Button text={'Post'} option={'green'} onClick={handleSave} />
                            </div>
                        </div>
                    ) : null
                }
            </div>

            {/* 1: Title & Event */}
            {
                phase1 ? (
                    <div className='section frame'>
                        <div className="info">
                            <p>Title</p>
                            <input
                                type="text"
                                name="title"
                                value={formData.title}
                                onChange={handleInputChange}
                                placeholder="Challenge title"
                                style={{ marginTop: '8px', boxSizing: 'border-box' }}
                                maxLength={65}
                            />
                        </div>
                        <div className="info">
                            <p>Image</p>
                            <input
                                type="text"
                                name="imageURL"
                                value={formData.imageURL}
                                onChange={handleInputChange}
                                placeholder="Image Link"
                                style={{ marginTop: '8px', boxSizing: 'border-box' }}
                            />
                            <p style={{ fontSize: 'small', marginTop: '4px', marginLeft: '8px' }}>Please use your images or images you have permission to use.</p>
                        </div>
                        <div className="info">
                            <div style={{ display: 'flex', alignItems: 'flex-end', gap: '8px' }}>
                                <p>Video</p>
                                <p style={{ fontSize: 'small' }}>(optional)</p>
                            </div>
                            <input
                                type="text"
                                name="videoURL"
                                value={formData.videoURL}
                                onChange={handleInputChange}
                                placeholder="Video Link"
                                style={{ marginTop: '8px', boxSizing: 'border-box' }}
                            />
                            <p style={{ fontSize: 'small', marginTop: '4px', marginLeft: '8px' }}>A link to an explanation video helps users better understand the challenge.</p>
                        </div>
                    </div>
                ) : null
            }

            {/* 2: Details (weeks, time, ...) */}
            {
                phase2 ? (
                    <div className='section frame'>
                        <div className="info">
                            <p>Event</p>
                            <input
                                type="text"
                                name="eventTitle"
                                value={formData.eventTitle}
                                onChange={handleInputChange}
                                placeholder="Event title"
                                style={{ marginTop: '8px', boxSizing: 'border-box' }}
                                maxLength={40}
                            />
                        </div>
                        <div className="weeks-events">
                            <div className="info">
                                <p>Weeks</p>
                                <p style={{ marginTop: 0, fontSize: "small" }}>How many weeks?</p>
                                {[1, 2, 3].map(week => (
                                    <div
                                        key={week}
                                        className={`clickable-div ${formData.weeks === week ? 'clicked' : ''}`}
                                        onClick={() => handleWeeksClick(week)}
                                    >
                                        {week}
                                    </div>
                                ))}
                            </div>
                            <div className="info">
                                <p>Events per Week</p>
                                <p style={{ marginTop: 0, fontSize: "small" }}>How many events per week?</p>
                                {[1, 2, 3, 4, 5, 6, 7].map(eventPerWeek => (
                                    <div
                                        key={eventPerWeek}
                                        className={`clickable-div ${formData.eventsPerWeek === eventPerWeek ? 'clicked' : ''}`}
                                        onClick={() => handleEventsPerWeekClick(eventPerWeek)}
                                    >
                                        {eventPerWeek}
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="info">
                            <p>Time of Event</p>
                            <p style={{ marginTop: 0, fontSize: "small" }}>Select the duration of the event</p>
                            {['5 min', '10 min', '20 min', '30 min', '1 hour', '2 hours', '4 hours'].map(eventTime => (
                                <div
                                    key={eventTime}
                                    className={`clickable-div ${formData.eventTime === eventTime ? 'clicked' : ''}`}
                                    onClick={() => handleEventTimeClick(eventTime)}
                                >
                                    <p style={{ fontWeight: 300 }}>{eventTime}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                ) : null
            }

            {/* 3: about & Tags */}
            {
                phase3 ? (
                    <div className='section frame'>
                        <div className="info">
                            <p>About</p>
                            <textarea
                                name="about"
                                value={formData.about}
                                onChange={handleInputChange}
                                placeholder="about for your challenge"
                                rows={10} // Initial number of rows (optional)
                                style={{ resize: 'none', overflowY: 'auto', width: '100%', boxSizing: 'border-box' }} // Optional styling to prevent manual resizing
                            />
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                            <p style={{ margin: '0' }}>Dimension</p>
                            <p style={{ margin: '0', fontSize: 'small' }}>(optional)</p>
                        </div>
                        <p style={{ margin: '0', fontSize: 'small', textAlign: 'left', marginBottom: '4px' }}>Choosing a category for this challenge will help the right users discover your challenge more easily.</p>

                        <select
                            id="category"
                            name="category"
                            value={formData.category}
                            onChange={handleInputChange}
                            required
                            style={{ width: '100%' }}
                        >
                            <option value="">Select a category</option>
                            <option value="other">Body (fitness, sports, nutrition, sleep, etc.) </option>
                            <option value="heart">Heart (family, hobbies, social, fun activities, etc.)</option>
                            <option value="mind">Mind (reading, learning, productivity, courses, etc.)</option>
                        </select>
                    </div>
                ) : null
            }

            {/* Week Events */}
            {
                formData.eventTitle ? (
                    <div className="section frame events-wrapper tight">
                        {
                            [...Array(formData.weeks)].map((_, weekIndex) => (
                                <div key={weekIndex}>
                                    <h4 style={{ textAlign: "left" }}>Week {weekIndex + 1}</h4>
                                    {
                                        [...Array(formData.eventsPerWeek)].map((_, eventIndex) => {

                                            return (
                                                <CreateEvent
                                                    key={`${weekIndex}-${eventIndex}`}
                                                    time={formData.eventTime}
                                                    title={formData.eventTitle}
                                                    eventNumber={eventIndex + 1}
                                                />
                                            );
                                        })
                                    }
                                </div>
                            ))
                        }
                    </div>
                ) : null
            }

            {/* Footer Margin */}
            <div style={{ display: 'flex', justifyContent: "center", alignItems: "center" }}>
                <div style={{
                    height: '20px',
                    width: '20px',
                    borderRadius: '50%',
                    backgroundColor: 'var(--colordarkgrey)',
                    marginTop: '180px',
                    marginBottom: '80px',
                    boxShadow: '2px 2px 5px rgba(0, 0, 0, 0.2)'
                }}>
                </div>
            </div>

            {/* Pop Up: Challenge Info */}
            {
                displayIntro ? (
                    <div className="intro-pop-up-container">
                        <div className="intro-pop-up">
                            <div className="intro-pop-up-header">
                                <div className="title">
                                    <h2 style={{ textAlign: 'left' }}>Create!</h2>
                                    <div
                                        className="close pointer"
                                        style={{
                                            backgroundImage: `url(${'https://logowik.com/content/uploads/images/close1437.jpg'})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat'
                                        }}
                                        onClick={handleCloseIntroPopUp}>
                                    </div>
                                </div>
                            </div>
                            <div className="intro-pop-up-scroll-view ">
                                <p style={{ textAlign: 'left' }}>Create your own challenges. Challenges are private unless posted on your channel.</p>
                            </div>
                        </div>
                    </div>
                ) : null
            }

            {/* Pop Up: Review Step Prompt */}
            {
                lastStepPopUp ? (
                    <div className="last-step-pop-up-container">
                        <div className="last-step-pop-up">
                            <div className="last-step-pop-up-header">
                                <div className="title">
                                    <h2 style={{ textAlign: 'left' }}>About</h2>
                                    <div
                                        className="close pointer"
                                        style={{
                                            backgroundImage: `url(${'https://logowik.com/content/uploads/images/close1437.jpg'})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat'
                                        }}
                                        onClick={handleCloseLastStepPopUp}
                                    >
                                    </div>
                                </div>
                            </div>
                            <div className="last-step-pop-up-scroll-view ">
                                {
                                    formData.about.split('\n\n').map((paragraph, index) => (
                                        <React.Fragment key={index}>
                                            <p style={{ marginBottom: '12px', textAlign: 'left' }}>{paragraph}</p>
                                        </React.Fragment>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                ) : null
            }

            {/* Pop Up: Saving Pop Up */}
            {
                savePopUp ? (
                    <div className="save-pop-up-container">
                        <div className="save-pop-up">
                            <div className="save-pop-up-header">
                                <div className="title">
                                </div>
                            </div>
                            {
                                saving ? (
                                    <div className="save-pop-up-scroll-view ">
                                        <p style={{ width: '100%', textAlign: 'center' }}>Saving</p>
                                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                                            <div className="saving-loading-circle"></div>
                                        </div>
                                    </div>
                                ) : (
                                    saved ? (
                                        <div className="save-pop-up-scroll-view ">
                                            <p style={{ width: '100%', textAlign: 'center' }}>Your challenge is posted!</p>
                                            <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                                                <Button text={'Go To Challenge'} option={'yellow'} onClick={handleGoToChallenge} />
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="save-pop-up-scroll-view ">
                                            <p style={{ width: '100%', textAlign: 'center' }}>Post this challenge to your challenges.</p>
                                            <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                                                <Button text={'Submit'} option={'green'} onClick={handleSubmitChallenge} />
                                            </div>
                                            <p style={{ textAlign: 'center', fontSize: 'small', width: '100%' }}>This challenge will be saved to your challenges. You can share it to your channel from there whenever you're ready.</p>
                                        </div>
                                    )
                                )
                            }
                        </div>
                    </div>
                ) : null
            }
        </div >
    );
};

export default Create;